import React from 'react';
import { Button, Spinner, TooltipTrigger } from '@spark';

// Play triangle (Figma "Run Play", 16px). The icon foundation has no play
// slug, so we draw the exact glyph inline.
const RunPlayIcon = () => (
    <span className="pg-run-icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M4.5 3.87v8.26c0 .79.87 1.27 1.54.85l6.56-4.13a1 1 0 0 0 0-1.7L6.04 3.02a1 1 0 0 0-1.54.85Z"
                fill="currentColor"
            />
        </svg>
    </span>
);

/**
 * Primary "Run all" control shared by the Playground top bar and the
 * examples toolbar. Disabled reason is shown as a tooltip when idle.
 */
const RunAllButton = ({ onRunAll, isRunning, runDisabled, runDisabledReason }) => {
    const button = (
        <Button
            variant="primary"
            size="small"
            disabled={runDisabled || isRunning}
            disableWhenReadOnly
            startIcon={isRunning ? <Spinner size="small" /> : <RunPlayIcon />}
            onClick={onRunAll}
        >
            {isRunning ? 'Running…' : 'Run all'}
        </Button>
    );
    if (runDisabledReason && !isRunning) {
        return (
            <TooltipTrigger text={runDisabledReason} placement="bottom">
                <span>{button}</span>
            </TooltipTrigger>
        );
    }
    return button;
};

export default RunAllButton;
